import { render, staticRenderFns } from "./ObjectList.vue?vue&type=template&id=43ada2ca&"
import script from "./ObjectList.vue?vue&type=script&lang=ts&"
export * from "./ObjectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports